
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bid-or-buy/[...slug]",
      function () {
        return require("private-next-pages/bid-or-buy/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bid-or-buy/[...slug]"])
      });
    }
  